import { createFavouritesApiClient } from './favouritesApiClient';
import type { FavouritesApiClient } from '@/scopes/common/domain/types/favourites';

export const favouritesAPIClient: FavouritesApiClient = createFavouritesApiClient();
